<template>
  <div class="guide-download">
    <img src="@/assets/img/download/app-logo.png" />
    <div class="app-info">
      <p class="app-name">中欧在线学习</p>
      <p class="app-summary">{{ $t("index.appstoryInfo") }}</p>
    </div>
    <button class="download-btn" @click="goDownload">
      {{ $t("index.downloadApp") }}
    </button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      androidApk: null,
    };
  },
  methods: {
    goDownload() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") !== -1;
      const formHost = location.host;
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        location.href = `https://${
          formHost.includes("eceibs.com.cn")
            ? "app.test.eceibs.com.cn"
            : "app.eceibs.net"
        }/openApp/#/downloadApp?iosDownload=1`;
      } else if (navigator.userAgent.match(/android/i)) {
        if (isWeixin) {
          return (window.location = `https://${
            formHost.includes("eceibs.com.cn")
              ? "app.test.eceibs.com.cn"
              : "app.eceibs.net"
          }/openApp/#/downloadApp`);
        }
        window.location.href = "eceibs://com.neweceibs.zo/splashactivity"; // android app协议(如：com.baidu.tieba://app)
        this.getDownloadAPK();
        setTimeout(() => {
          if (!this.androidApk) {
            return this.$toast("正在获取安装包地址，请稍后再试");
          }
          window.location = this.androidApk; // android 下载地址
        }, 1500);
      }
    },
    getDownloadAPK() {
      this.$axios
        .post("index.php/mobile/app/last-apk", {
          app_sys_id: 0,
        })
        .then((res) => {
          if (res.data.code !== 0) {
            this.$toast(res.data.msg);
          } else {
            this.androidApk = res.data.result.download_url;
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/sass/color.less";
.guide-download {
  display: flex;
  padding: 0.17rem 0.28rem 0.15rem;
  box-shadow: 0px 5px 18px 0px rgba(179, 179, 179, 0.21);
  align-items: center;
  background: white;
  img {
    width: 0.8rem;
    height: 0.8rem;
  }
  .app-info {
    flex: 1;
    margin: 0 0.1rem;
    overflow: hidden;
    .app-name {
      font-size: 0.28rem;
      font-weight: 700;
    }
    .app-summary {
      font-size: 0.22rem;
      color: #777777;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .download-btn {
    background: none;
    border: @mColor 0.02rem solid;
    color: @mColor;
    font-size: 0.24rem;
    height: 0.5rem;
    border-radius: 0.25rem;
    padding: 0 0.18rem;
  }
}
</style>
